import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export interface Repository {
  artifactName: string;
  repositoryId: string;
  integrationId: string;
}

export interface RepositoryTypesResponse {
  node?: Repository[];
}

// Hooks
export const useRepositoryTypes = ({
  integrationIds,
  enabled,
}: { integrationIds?: string[]; enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['repositoryTypes', ...(integrationIds ?? [])],
    queryFn: async () => {
      const path =
        integrationIds && integrationIds.length > 0
          ? `/api/code/repositories/types?integrationIds=${integrationIds.join(',')}`
          : '/api/code/repositories/types';
      const { data } = await api.get<{ data: RepositoryTypesResponse }>(path);
      return data.data;
    },
    enabled: enabled ?? true,
  });
};
